import { BodilColor } from '~src/branding';
import { BODIL_PRIVACY_POLICY_URL } from '~src/constants';
import { LEAD_ORIGIN_NORLYS, useLeadOrigin } from '~src/hooks/useLeadOrigin';

export const useGdprConsent = (leadOrigin?: string) => {
  const { origin } = useLeadOrigin();

  const privacyLink = (
    <a href={BODIL_PRIVACY_POLICY_URL} target='_blank' rel='noreferrer' style={{ color: BodilColor.ui.success }}>
      privatlivspolitikken
    </a>
  );

  switch (leadOrigin ?? origin) {
    case 'edc':
    case LEAD_ORIGIN_NORLYS:
      return (
        <>
          Ved at fortsætte giver jeg samtykke til, at Bodil Energi må kontakte mig pr. e-mail og telefonisk med en
          skræddersyet energirapport og tilbud baseret på de oplysninger, jeg har afgivet (navn, kontaktoplysninger,
          adresse, oplysninger om bolig). Jeg kan til enhver tid tilbagekalde mit samtykke. Nærmere information om Bodil
          Energis behandling af personoplysninger fremgår af {privacyLink}.
        </>
      );
    case 'nordea':
      return (
        <>
          Ved at fortsætte giver jeg samtykke til, at Bodil Energi må kontakte mig pr. e-mail og telefonisk med en
          skræddersyet energirapport og tilbud baseret på de oplysninger, jeg har afgivet (navn, kontaktoplysninger,
          adresse, oplysninger om bolig). Bodil Energi kan efterfølgende videregive oplysninger om resultatet af mine
          initiativer og mine aftaler med Bodil Energi til Nordea med henblik på mulig finansiering af tilbuddet. Jeg
          kan til enhver tid tilbagekalde mit samtykke. Nærmere information om Bodil Energis behandling af
          personoplysninger fremgår af {privacyLink}.
        </>
      );
    case 'jyskebank':
      return (
        <>
          Jeg giver hermed samtykke til, at Bodil Energi må kontakte mig pr. e-mail og telefonisk med en skræddersyet
          energirapport og tilbud baseret på de oplysninger, jeg har afgivet (navn, kontaktoplysninger, adresse,
          oplysninger om bolig). Bodil Energi kan efterfølgende videregive oplysninger om resultatet af mine initiativer
          og mine aftaler med Bodil Energi til Jyske Bank med henblik på mulig finansiering af tilbuddet. Jeg kan til
          enhver tid tilbagekalde mit samtykke. Nærmere information om Bodil Energis behandling af personoplysninger
          fremgår af {privacyLink}.
        </>
      );
    default:
      return (
        <>
          Ved at fortsætte giver jeg samtykke til, at Bodil Energi må kontakte mig pr. e-mail og telefonisk med en
          skræddersyet energirapport og tilbud baseret på de oplysninger, jeg har afgivet (navn, kontaktoplysninger,
          adresse, oplysninger om bolig). Jeg accepterer, at Energirapporten kan indeholde information om
          finansieringsmuligheder. Jeg kan til enhver tid tilbagekalde mit samtykke. Nærmere information om Bodil
          Energis behandling af personoplysninger fremgår af {privacyLink}.
        </>
      );
  }
};
